import { render } from "./News-Details.vue?vue&type=template&id=f3412d3a&scoped=true"
import script from "./News-Details.vue?vue&type=script&lang=js"
export * from "./News-Details.vue?vue&type=script&lang=js"

import "./News-Details.vue?vue&type=style&index=0&id=f3412d3a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f3412d3a"

export default script